import type { FC } from 'react';

import { Alert } from '@sravni/react-design-system/lib/Alert';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Dialog } from '@sravni/react-design-system/lib/Dialog';
import { Sheet } from '@sravni/react-design-system/lib/Sheet';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { PROMO_GUIDE_SHEET_LINK } from './PromoGuideSheet.config';
import styles from './PromoGuideSheet.module.scss';
import { PromoGuideSheetTexts } from './PromoGuideSheet.texts';

type PromoGuideSheetProps = { visible: boolean; onClose: () => void; onButtonClick: () => void };

export const PromoGuideSheet: FC<PromoGuideSheetProps> = ({ visible, onClose, onButtonClick }) => {
  const isMobile = useIsMobile();

  const Variant = isMobile ? Sheet : Dialog;

  return (
    <Variant visible={visible} onClose={onClose} className={styles.container}>
      <Variant.Header>
        <Text size={20} className={styles.title} strong>
          {PromoGuideSheetTexts.title}
        </Text>
      </Variant.Header>
      <Variant.Content>
        <Space direction="vertical" size={16}>
          <Space direction="vertical" size={16}>
            <Text className={styles.content}>{PromoGuideSheetTexts.content}</Text>
            <Alert variant="secondary" className={styles.description} color="dark">
              {PromoGuideSheetTexts.description}
            </Alert>
          </Space>

          <a
            onClick={() => {
              window.open(PROMO_GUIDE_SHEET_LINK, '_blank', 'noopener');
            }}
          >
            {PromoGuideSheetTexts.linkText}
          </a>
        </Space>
      </Variant.Content>
      <Variant.Footer>
        <Button onClick={onButtonClick} variant="primary" size={52} block>
          {PromoGuideSheetTexts.buttonText}
        </Button>
      </Variant.Footer>
    </Variant>
  );
};
